import {companyTypes} from "../actions/_company_actions";
import {initalizerTypes} from "../actions/initializer_actions"
const companyReducerDefaultState = {
    companyName: '',
    companyAbout: '',
    companyVideo: 'https://www.youtube.com/watch?v=a1Y73sPHKxw',
    established: '',
    proportion: '',
    avAge: '',
    employeeCount: '',
    companyLogo: '',
    companyEmail: '',
    companyWebsite: '',
    colaborators: [{link: '', name: '', title: '', commentary: ''},{link: '', name: '', title: '', commentary: ''},{link: '', name: '', title: '', commentary: ''}],
    companyCulture: [{title: '', cultureLongform: '', img: ''}],
    locationName: '',
    latlang: []
};

export default (state = companyReducerDefaultState, action) => {
    switch (action.type) {
        case initalizerTypes.FETCH_COMPANY_DATA:
            return {
                ...action.data
            };
        case companyTypes.PUBLISH_DATA:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}